import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { formatDate } from "@/lib/dateUtils";

export default function CaseDonationsList({ caseId }) {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/cases/${caseId}/donations`).then(({ data }) => {
      setDonations(data.items);
      setLoading(false);
    });
  }, [caseId]);

  if (loading) {
    return (
      <div className="flex justify-center py-3">
        <Loader2 className="h-4 w-4 animate-spin text-amtm-teal" />
      </div>
    );
  }
  if (donations.length === 0) return null;

  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-2xl p-4 mb-6" data-testid="case-donations-list">
      <p className="text-xs text-amtm-textMuted mb-2">Razorpay Donations ({donations.length})</p>
      <div className="space-y-2 max-h-64 overflow-y-auto">
        {donations.map((d) => (
          <div key={d.id} className="flex items-center justify-between text-sm" data-testid={`donation-row-${d.id}`}>
            <div>
              <p className="text-amtm-text font-medium">{d.donor_name || "Anonymous"}</p>
              <p className="text-amtm-textMuted text-xs">{formatDate(d.created_at)}</p>
            </div>
            <p className="font-semibold text-amtm-success">₹{d.amount.toLocaleString("en-IN")}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
